export default "__VITE_ASSET__BPFp16Uh__"